(function( $ ) {
  'use strict';

  $(window).load(function() {
    $(".resources-group .resources-row .resource .label-container").click( function() {
      const row = $(this).closest(".row.resource-row");

      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).next(".content-container.active").slideUp();
      }
      else {
        $(this).addClass("active");
        $(this).next(".content-container").stop().slideToggle().addClass("active");
      }
    });
  })
})( jQuery );
